const Locations = {
	'localhost:8080':'http://localhost:8081/', // Only use when needed
	//'localhost:8080':'http://localhost/pocket-box/api/', // Only use when needed
	'dev-fleet.pocketbox.co':'https://dev-api.pocketbox.co/',
	'fleet.pocketbox.co':'https://api.pocketbox.co/',
}
const Endpoint = Locations[window.location.host]+'fleet/';
const GlobalEndpoint = Locations[window.location.host];
// const Endpoint = 'https://api.pocketbox.co/plus/'
// const GlobalEndpoint = 'https://api.pocketbox.co/'
export default {
	Helper : {
		File : {
			Upload : GlobalEndpoint + 'fleet/file/upload',
			Get : GlobalEndpoint + 'fleet/file/get'
		},
		VehicleImage : GlobalEndpoint+'vehicle/image/',
		Image : GlobalEndpoint+'image',
		GenerateImage : GlobalEndpoint+'image/create',
	},
	User : {
		Login : Endpoint+'user/login',
		Google2faBarcodeURL : Endpoint+'user/google/auth/barcode',
		Google2faBarcodeVerify : Endpoint+'user/google/auth/otp/verify',
		Reset2FA : Endpoint+'user/google/2fa/reset',
		Password : {
			Reset : Endpoint+'user/password/reset',
			Update : Endpoint+'user/password/update'
		},
		Verify : Endpoint+'user/verify',
		Profile : {
			Image : {
				Get : Endpoint + 'user/profile/image/get',
				Set : Endpoint + 'user/profile/image/set'
			}
		},
		Company : Endpoint+'company/get',
		Details : {
			Get : Endpoint+'user/details/get',
			Set : Endpoint+'user/details/set',
		},
		AllUser : Endpoint+'alluser/bycompany',
		Delete : Endpoint+'user/remove',
		Create : Endpoint+'user/create',
		Update:Endpoint + 'user/update',
		Get: Endpoint + 'user/get',
	},
	Dashboard : {
		DashboardData : Endpoint+'dashboard',
		DashboardReport : Endpoint+'dashboard/report/get',
		DashboardReportData : Endpoint+'dashboard/report/data/get',
		UpcomingEvent : Endpoint+'dashboard/upcoming_event',
		UpcomingEventVehicle : Endpoint+'dashboard/upcoming_event_vehicle',
		UpcomingEventVehicleChecks : Endpoint+'dashboard/upcoming_event_vehiclechecks',
		UpcomingEventDocuments : Endpoint+'dashboard/upcoming_event_document',
		UpcomingEventDrivers : Endpoint+'dashboard/upcoming_event_driver',
		UpcomingEventAssets : Endpoint+'dashboard/upcoming_event_assets',
		UpcomingEventRepair : Endpoint+'dashboard/upcoming_event_repair',
		UpcomingEventManualTask : Endpoint+'dashboard/upcoming_event_manual_task',
		UpcomingEventSubmit : Endpoint+'dashboard/upcoming_event_submit',
		VehicleCheckDueList : Endpoint+'dashboard/vehicle_check_due_list',
		VehicleInspectionsDueList : Endpoint+'dashboard/vehicle_inspections_due_list',
		VehicleInspectionsLastOneMonth : Endpoint+'dashboard/vehicle/inspections/get',
		VehicleInspectionRectifications : Endpoint+'dashboard/vehicle/inspections/rectifications/list',		
	},		
	Trailer : {
		List : Endpoint+'trailers/list',
		Create : Endpoint+'trailer/create',
		GetTrailerMake : Endpoint+'trailer/get_trailer_make',
		GetTrailerModel : Endpoint+'trailer/get_trailer_model',
		GetTrailerTypes : Endpoint+'trailer/get_trailer_types',
		Get : Endpoint+'trailer/get',
		Update : Endpoint+'trailer/update',
		Delete : Endpoint+'trailer/delete',
		ListForAssign : Endpoint+'vehicles/list-for-assign-trailer',
		AssginVehicle : Endpoint+'trailer/assgin-vehicle',
		UnAssginVehicle : Endpoint+'trailer/unassgin-vehicle',
		ListForAssignTrailer : Endpoint+'trailer/list-for-assign-trailer',
		TrailerChecksDetail : Endpoint+'trailer/check/details',
	},
	Vehicle : {
		Data : GlobalEndpoint+'vehicle/data',
		DashboardData : Endpoint+'vehicle/dashboard',
		List : Endpoint+'vehicles/list',
		ListPlain : Endpoint+'vehicles/list_plain',
		ListWithSafeStatus : Endpoint+'vehicles/list_withsafestatus',
		ListForAssign : Endpoint+'vehicles/list-for-assign',
		Create : Endpoint+'vehicle/create',
		Update : Endpoint+'vehicle/update',
		Delete : Endpoint+'vehicle/delete',
		Get : Endpoint+'vehicle/get',
		History : Endpoint+'vehicle/history',
		Image : GlobalEndpoint+'vehicle/image',
		SaleDetails : Endpoint+'vehicle/sale/updatesaledetails',
		VehicleDetails : Endpoint+'vehicle/updatevehicledetails',
		BeingRepaired : Endpoint+'vehicle/being-repaired',
		CompleteRepairing : Endpoint+'vehicle/complete-repairing',
		Sorn : Endpoint+'vehicle/sorn',
		Unsorn : Endpoint+'vehicle/unsorn',
		Services : Endpoint+'vehicle/services',
		Insurances : Endpoint+'vehicle/insurances',
		CheckFailure : Endpoint+'vehicle_check/failure_for_vehicle',
		FixCheckFailure : Endpoint+'vehicle_check/fix_failure_for_vehicle',
		Documents : Endpoint+'vehicle/documents',
		DocumentSubcategories : Endpoint+'vehicle/document/subcategories',
		DocumentPagination : Endpoint+'vehicle/document/pagination/get',
		GetVehicleFleetNumber : Endpoint+'vehicle/get_vehicle_fleet_number',
		GetVehicleTypes : Endpoint+'vehicle/get_vehicle_types',
		GetVehicleMake : Endpoint+'vehicle/get_vehicle_make',
		GetVehicleModel : Endpoint+'vehicle/get_vehicle_model',
		GetInseegoData : Endpoint+'vehicle/inseego/get_node_id',		
		GetInseegoVehiclePosition : Endpoint+'vehicle/inseego/get_vehicle_current_position',
		GetInseegoVehiclePositionAll : Endpoint+'vehicle/inseego/get_vehicle_current_position_all',
		GetInseegoVehicleTrips : Endpoint+'vehicle/inseego/get_vehicle_trips',
		Classes: Endpoint + 'vehicle/class/list',
		AssignedAssets: Endpoint + 'vehicle/get_assigned_assets',
		CalculateNextPmi: Endpoint + 'vehicle/get_next_pmi_date',		
	},
	Notes : {
		Create : Endpoint+'notes/create',
		Update : Endpoint+'notes/update',
		List : Endpoint+'notes/list',
		Delete : Endpoint+'notes/delete',
	},
	Groups : {
		Create : Endpoint+'group/create',
		Get : Endpoint+'group/get',
		List : Endpoint+'group/list',
		Delete : Endpoint+'group/delete',
		VehicleList : Endpoint+'group/vehicle/list',
	},
	Dcoument : {
        //Modal : 'https://dev-api.pocketbox.co/document/model',
		Model : Endpoint+'document/model/get',
		Create : Endpoint+'document/create',
		Update : Endpoint+'document/update',
		Delete : Endpoint+'document/delete',
		List : Endpoint+'documents/get',
		Get : Endpoint+'vehicle/get',
		AddFile : Endpoint+'document/addfile',
		Categories : Endpoint+'document/category/list',
		SubCategories : Endpoint+'document/subcategory/list',
		CategoryCreate : Endpoint+'document/category/create',
		CategoryUpdate : Endpoint+'document/category/update',
		SendDocument : Endpoint+'document/send',
		CategoryDelete : Endpoint+'document/category/delete',
		VehicleList : Endpoint+'document/vehicles', 
		DocumentPagination : Endpoint+'document/pagination/get',
		GenerateLicensePdf : Endpoint+'generate/license/pdf',
		LitresUpdate : Endpoint+'document/litres/update',
		TransactionAccept : Endpoint+'document/accept/transaction',
		FuelDataMerge : Endpoint+'document/fueldatamerge',
	},
	File : {
		//Upload : GlobalEndpoint+'file/upload',
		Upload : Endpoint+'file/upload',
		Get : Endpoint+'file/get',
		GetBase64Image : Endpoint + 'file/get_base64_image',
	},
	Driver : {
		List : Endpoint+'drivers/list',
		Create : Endpoint+'driver/create',
		Update : Endpoint+'driver/update',
		Delete : Endpoint+'driver/delete',
		StatusUpdate : Endpoint+'driver/status/update',
		Get : Endpoint+'driver/get',
		AssginVehicle : Endpoint+'driver/assgin-vehicle',
		UnAssginVehicle : Endpoint+'driver/unassgin-vehicle',
		UnfitToDrive : Endpoint+'driver/unfit-to-drive',
		FitToDrive : Endpoint+'driver/fit-to-drive',
		Documents : Endpoint+'driver/documents',
		DocumentSubcategories : Endpoint+'driver/document/subcategories',
		UnlinkDocument : Endpoint+'driver/unlink_document',
		GetSubscription : Endpoint+'subscription/get',
		AssignedAssets : Endpoint + 'driver/get_assigned_assets',
		SendCustomNotification : Endpoint + 'driver/send/custom/notification',
		ResetAppPassword : Endpoint + 'driver/reset/app/password',
		DisconnectAPPUser : Endpoint + 'driver/disconnect/app/user',
		registerDriverOnMobile : Endpoint + 'driver/register/on/mobile',
		connectDriverWithMobileUser : Endpoint + 'driver/connect/with/mobile/user',
	},
	VehicleChecks : {
		GetCompanyChecks : Endpoint+'vehicle_checks/get_company_checks',
		SaveCompanyChecks : Endpoint+'vehicle_checks/save_company_checks',
		DeleteCompanyChecks : Endpoint+'vehicle_checks/delete_company_checks',
		VehicleChecksList : Endpoint+'vehicle_checks/get_list',		
		VehicleCheckView : Endpoint+'vehicle_check/get_detail',
		GetCheckClassList : Endpoint+'vehicle/check/class/list',
		AddNewClass : Endpoint+'vehicle/check/class/add',
		DeleteClass : Endpoint+'vehicle/check/class/delete',
		GetVehicleClassList : Endpoint+'vehicle/classes/list',
		GeneratePDF : Endpoint+'vehicle_checks/generate_pdf',
		VehicleCheckStats : Endpoint+'vehicle_checks/stats/get',
		VehicleCheckMarkSafe : Endpoint+'vehicle_check/marksafe',
		GetVehicleFailedCheck : Endpoint+'vehicle_check/get_failed_checks',						
		GetVehicleFailedCheckVehicle : Endpoint+'vehicle_check/get_failed_checks_vehicle',	
		MarkSafeVehicle : Endpoint+'vehicle_check/marksafevehicle',					
	},
	VehicleInspections : {
		GetCompanyInspections : Endpoint+'vehicle_inspections/get_company_inspections',
		SaveCompanyInspections : Endpoint+'vehicle_inspections/save_company_inspections',
		DeleteCompanyInspections : Endpoint+'vehicle_inspections/delete_company_inspections',
		VehicleInspectionsList : Endpoint+'vehicle_inspections/get_list',
		VehicleInspectionView : Endpoint+'vehicle_inspections/get_detail',
		GetCategoriesList : Endpoint+'vehicle_inspections/category/list',
		InspectionsList : Endpoint+'vehicle_inspections/list',
		Create : Endpoint+'vehicle_inspections/submit/web',
		GenerateURL : Endpoint+'vehicle_inspections/generate/submit/url',
		SendMail : Endpoint+'vehicle_inspections/send/email',
		SubmitInspectionDetails : Endpoint+'vehicle_inspections/get_detail/web',
		GetMechanics : Endpoint+'vehicle_inspections/mechanic/list',
		GetVehicles : Endpoint+'vehicle_inspections/vehicle/list',
		GetVehicleClasses : Endpoint+'vehicle_inspections/vehicle/classes/list',
		InspectionDelete : Endpoint+'vehicle_inspections/delete',
		AddNewClass : Endpoint+'vehicle/inspection/class/add',
		CategoryUpdate : Endpoint+'vehicle_inspections/category/update',
		DeleteCategory : Endpoint+'vehicle_inspections/category/delete',
		CategoryAdd : Endpoint+'vehicle_inspections/category/add',
		DeleteClass : Endpoint+'vehicle_inspections/class/delete',
	},
	Company : {
		Links : Endpoint+'company/set/links',
		Get : Endpoint+'company/get',
		Update: Endpoint + 'company/update',
		LogoSet: Endpoint + 'company/logo/set',
		BannerSet: Endpoint + 'company/banner/set',
	},
	Operation : {
		ImageDelete : Endpoint+'image/delete',
	},
	Branch : {
		List : Endpoint+'branches/list',
		Get : Endpoint+'branch/get',
		Create : Endpoint+'branch/create',
		Update : Endpoint+'branch/update',
		Delete : Endpoint+'branch/delete',
	},
	Roles : {
		List : Endpoint+'roles/list',
		Permission : Endpoint+'user/role/permissions/get',
		Delete : Endpoint+'role/delete',
		Create : Endpoint+'role/create',
		Get : Endpoint+'role/details/get',
		Update : Endpoint+'role/update',
		PermissionsList: Endpoint + 'account/role/permissions/get'
	},
	Modules:{
		List : Endpoint+'company/modules/list',
	},
	AuditLog : {
		List : Endpoint+'auditlog/list',
	},
	Report : {		
		TotalStats : Endpoint+'report/totalstats',						
		TotalExpire : Endpoint+'report/totalexpire',						
		DriverPoints : Endpoint+'report/driverpoints',														
		CheckFailures : Endpoint+'report/checkfailures',						
		TotalWarningFailure : Endpoint+'report/totalwarningfailure',		
		VehiclesByAge : Endpoint+'report/vehiclesbyage',				
		VehiclesByMileage : Endpoint+'report/vehiclesbymileage',
		FuelByVehicle : Endpoint+'report/fuelbyvehicle',
		FuelByMultipleVehicle : Endpoint+'report/fuelbyvehicles',
		FuelReportGet : Endpoint+'fuel/report/get',
		FuelList : Endpoint+'fuel/list',
		VehicleCheckList: Endpoint+'report/vehiclechecks',
		FuleCardLiters : Endpoint+'fuel/card/litlers/get',
	},
	ReportsTable : {	
		VehiclesList : Endpoint+'reports/vehicles/list',
		DriversList : Endpoint+'reports/drivers/list',
		TrailersList : Endpoint+'reports/trailers/list',
		AssetsList : Endpoint+'reports/assets/list',
	},
	ImportExcel : {		
		Drivers : Endpoint+'importexcel/drivers',						
		Vehicles : Endpoint+'importexcel/vehicles',
		Trailers : Endpoint+'importexcel/trailers',
		Fuel : Endpoint+'importexcel/fuel',
		Assets : Endpoint+'importexcel/assets',
	},	
	Assets : {
		List : Endpoint+'assets/list',
		Get : Endpoint+'assets/get',
		Create : Endpoint+'assets/create',
		Update : Endpoint+'assets/update',
		Delete : Endpoint+'assets/delete',
		GetUnsafeAsset : Endpoint+'assets/unsafe/get',

		Category : {
			List : Endpoint+'assets/category/list',
			Get : Endpoint+'assets/category/get',
			Create : Endpoint+'assets/category/create',
			Update : Endpoint+'assets/category/update',
			Delete : Endpoint+'assets/category/delete',
		},
		Location : {
			List : Endpoint+'assets/location/list',
			Get : Endpoint+'assets/location/get',
			Create : Endpoint+'assets/location/create',
			Update : Endpoint+'assets/location/update',
			Delete : Endpoint+'assets/location/delete',
		},
		Group : {
			List : Endpoint+'assets/group/list',
			Get : Endpoint+'assets/group/get',
			Create : Endpoint+'assets/group/create',
			Update : Endpoint+'assets/group/update',
			Delete : Endpoint+'assets/group/delete',
		},
		Ownership : {
			List : Endpoint+'assets/ownership/list',
			Get : Endpoint+'assets/ownership/get',
			Create : Endpoint+'assets/ownership/create',
			Update : Endpoint+'assets/ownership/update',
			Delete : Endpoint+'assets/ownership/delete',
		},
		Assignments : {			
			Delete : Endpoint+'assets/assignments/delete',
		},
		Template : {			
			List : Endpoint+'assets/templates/list',
			Delete : Endpoint+'assets/template/delete',
			Update : Endpoint+'assets/template/update',
			Create : Endpoint+'assets/template/create',
		},
		TemplateChecks : {			
			List : Endpoint+'assets/template/checks/list',
			Create : Endpoint+'assets/template/check/create',
			Delete : Endpoint+'assets/template/check/delete',
		},
		Checks : {
			List : Endpoint+'asset/checks/list',
			Details : Endpoint+'asset/check/details/get',
			marksafe : Endpoint+'asset/check/marksafe',
			GetAssetFailedCheck : Endpoint+'asset/check/get_failed_checks',
			marksafeAsset : Endpoint+'asset/check/marksafeasset',
			GetAssetFailedCheckAssets : Endpoint+'asset/check/get_failed_checks_asset',
		},
		GetAssetsFieldValues : Endpoint+'assets/get_assets_field_values',
		DriverOwnershipLink : Endpoint+'asset/driver/ownership/list',
	},
	FleetSubscription: {
		List: Endpoint + 'subscriptions/get',
	},
	QR : {
		Generate : GlobalEndpoint+'qr/generate'
	},
	EmailPreferences  : {
		List : Endpoint+'email-preferences/get',
		StatusUpdate : Endpoint+'email-preferences/status/update',
		Update : Endpoint+'email-preferences/update',
	},
	Task : {
		List : Endpoint+'task/list',
		Create : Endpoint+'task/create',
		GET_LIST : Endpoint+'task/get_list',
		TaskSubmit : Endpoint+'task/submit',		
		BookRepair : Endpoint+'task/book_repair',		
		BookServiceAppointment : Endpoint+'task/book_service_appointment',		
	},	
	SupportTicket : {
		Create : Endpoint+'support/ticket/create',
	},
}
